import { Controller } from '@hotwired/stimulus';
import application from '~/stimulus_application';

export default class SearchFieldController extends Controller {
  static targets = ['input'];
  static values = {
    delay: { type: Number, default: 300 },
    minLength: { type: Number, default: 0 },
  };

  declare readonly inputTarget: HTMLInputElement;
  declare readonly delayValue: number;
  declare readonly minLengthValue: number;
  private timeout: number | null = null;

  input() {
    if (this.timeout) {
      window.clearTimeout(this.timeout);
    }

    this.timeout = window.setTimeout(() => {
      const value = this.inputTarget.value.trim();

      // If minLength is set and input is below it, don't submit
      if (this.minLengthValue > 0 && value.length < this.minLengthValue) {
        return;
      }

      const form = this.inputTarget.closest('form');
      if (form) {
        form.requestSubmit();
      }
    }, this.delayValue);
  }
}

// Convert Ui::Form::SearchField to ui--form--search-field
const controllerName = 'ui--form--search-field';
application.register(controllerName, SearchFieldController);
